import { createContext, useContext } from "react";

type ViewportControlsContextValue = {
  activeBreakpointKey?: string;
  setViewportAuto: () => void;
  setViewportFixedWidth: (width: number) => void;
};

const ViewportControlsContext = createContext<ViewportControlsContextValue | null>(null);

export const ViewportControlsProvider = ViewportControlsContext.Provider;

export const useViewportControls = () => useContext(ViewportControlsContext);
